{
  "Earlier": "ANTERIOR",
  "newNotification": "{newCount} notificación nueva",
  "newNotifications": "{newCount} nuevas notificaciones",
  "noNotifications": "Recibirá información importante sobre nuestros productos, su colaboración con otros usuarios y otras actualizaciones relevantes.",
  "noNotificationsTitle": "Sus notificaciones aparecerán aquí"
}
